module.exports = __webpack_public_path__ + "img/tiles.c79633c3.svg";